<template>
  <div class="header">
    <span>{{ title1 }}</span
    ><span>{{ title2 }}</span>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    title1: String,
    title2: String
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.header {
  margin-bottom: 36px;
  span {
    font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
      Verdana, 'PingFang SC';
    font-size: 30px;
    letter-spacing: 0;
    line-height: 42px;
    font-weight: bold;
    &:first-child {
      color: #333333;
    }
    &:last-child {
      color: #999999;
      margin-left: 16px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/moduleTitle.vue